import { render, staticRenderFns } from "./OperationDogane.vue?vue&type=template&id=05b72076&scoped=true"
import script from "./OperationDogane.vue?vue&type=script&lang=ts"
export * from "./OperationDogane.vue?vue&type=script&lang=ts"
import style0 from "./OperationDogane.vue?vue&type=style&index=0&id=05b72076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b72076",
  null
  
)

export default component.exports